import { api } from '@/lib/customFetch'
import type {
  DocumentType,
  CreateDocumentTypeInput,
  UpdateDocumentTypeInput,
} from '@/lib/types/ged'

export const typeKeys = {
  all: () => ['document-types'] as const,
  byArea: (areaId: string) => ['document-types', 'by-area', areaId] as const,
}

export async function listDocumentTypes(): Promise<DocumentType[]> {
  return api.get<DocumentType[]>('/documents/types')
}

export async function createDocumentType(data: CreateDocumentTypeInput): Promise<DocumentType> {
  return api.post<DocumentType>('/documents/types', data)
}

export async function updateDocumentType(
  id: string,
  data: UpdateDocumentTypeInput,
): Promise<DocumentType> {
  return api.patch<DocumentType>(`/documents/types/${id}`, data)
}

export async function reorderDocumentTypes(ids: string[]): Promise<void> {
  return api.patch<void>('/documents/types/reorder', { ids })
}

export async function deleteDocumentType(id: string): Promise<void> {
  return api.delete<void>(`/documents/types/${id}`)
}
